export const isEmailInFrequentList = (email, frequentEmails, serverFrequentEmails) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase();
  const localEmails = Array.isArray(frequentEmails) ? frequentEmails : [];
  const serverEmails = Array.isArray(serverFrequentEmails) ? serverFrequentEmails : [];
  const inLocalList = localEmails.some(item => 
    item && item.email && item.email.toLowerCase() === normalizedEmail
  );
  if (inLocalList) return true;
  const inServerList = serverEmails.some(item => 
    item && item.email && item.email.toLowerCase() === normalizedEmail
  );
  return inServerList;
};

export const findCompanyByName = (companyName, companies) => {
  if (!companyName || !companies || !Array.isArray(companies)) return null;
  
  const normalizedName = companyName.toLowerCase();
  return companies.find(company => 
    company.company_name && company.company_name.toLowerCase() === normalizedName
  ) || null;
};
export const addRecipientToFrequent = async (
  emailData, 
  companies,
  createCompany,
  createEmail,
  queryParams,
  getCompanyList
) => {
  try {
    let companyId = null;
    const existingCompany = findCompanyByName(emailData.company, companies);
    
    if (!existingCompany) {
      try {
        const companyData = {
          company_name: emailData.company,
          company_tel: '',
          company_address: '',
          place_no: queryParams.place_no,
          company_no: queryParams.company_no,
          recipient_company_no: emailData.recipient_company_no || '',
          recipient_place_no: emailData.recipient_place_no || '',
          recipient_place_name: emailData.recipient_place_name || ''
        };
        
        const newCompany = await createCompany(companyData, queryParams);
        try {
          const updatedCompanies = await getCompanyList(queryParams.place_no, queryParams.company_no);
          const createdCompany = findCompanyByName(emailData.company, updatedCompanies);
          
          if (createdCompany && createdCompany.id) {
            companyId = createdCompany.id;
          } else if (newCompany && newCompany.id) {
            companyId = newCompany.id;
          } else if (newCompany && typeof newCompany === 'object') {
            const possibleId = Object.values(newCompany).find(val => typeof val === 'number');
            companyId = possibleId || 1;
          } else {
            companyId = 1;
          }
        } catch (fetchError) {
          console.error("Error fetching updated company list:", fetchError);
          
          // Try to use the ID from the response
          if (newCompany && newCompany.id) {
            companyId = newCompany.id;
            companyId = 1;
          }
        }
      } catch (error) {
        console.error("Error creating company:", error);
        companyId = 1;
      }
    } else {
      companyId = existingCompany.id;
    }
    try {
      const emailBodyData = {
        receiver_email: emailData.email,
        receiver_name: emailData.name,
        company_name: emailData.company,
        receiver_company_id: companyId,
        place_no: queryParams.place_no,
        company_no: queryParams.company_no
      };

      await createEmail(emailBodyData, queryParams);
      
      return { 
        newCompanyId: companyId,
        success: true
      };
    } catch (emailError) {
      console.error(`Error adding email ${emailData.email}:`, emailError);
      return {
        newCompanyId: companyId,
        success: false,
        error: emailError.message || "Error adding email"
      };
    }
  } catch (error) {
    console.error("Failed to add recipient to frequent list:", error);
    // Attempt to get more detailed error information
    let errorMessage = "Unknown error";
    if (error && error.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    } else if (error && error.toString) {
      errorMessage = error.toString();
    }
    
    return { 
      newCompanyId: null,
      success: false,
      errorMessage
    };
  }
};
